module.exports = "/_next/static/images/afuri_top-00f7514cc34048396b6e69a5e9986313.jpg";